module.exports = __webpack_public_path__ + "img/潜江市中医院.c044fd2f.png";